var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.89718 6.79294C3.06901 6.6211 3.34761 6.6211 3.51944 6.79294L11 14.2735L18.4805 6.79294C18.6523 6.6211 18.9309 6.6211 19.1028 6.79294C19.2746 6.96477 19.2746 7.24336 19.1028 7.41519L11 15.518L2.89718 7.41519C2.72535 7.24336 2.72535 6.96477 2.89718 6.79294Z",
    fill: "#08081B",
    stroke: "#08081B",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/DownArrow.36125e718fbc1994cfff8b7781471630.svg";
export { ForwardRef as ReactComponent };